const form_template = `
    <div class='row'>
        <div class='col-lg-12'>
            <amt-form-inline
                name='retention.DeviceSegmentsForm'
                on-submit='updateCharts(model)'
                extend-model='$root.chartParams.filters'
            >
            </amt-form-inline>
        </div>
    </div>
`;
const main_view = {
    template: require('./view.html'),
};
const state_config = {
    url: '/devices',
    reloadOnSearch: false,
    data: {
        priority: 890,
        title: 'Devices',
    },
    views: {
        '': main_view,
        'main-filter@amt.ww2': {
            template: form_template,
        },
    },
};
export default state_config;
